module.exports = __webpack_public_path__ + "img/18-min.08f0b44c.jpg";